const checkPartnerSideBar = (props) => {
  if (props.location.pathname.indexOf('admin/admincentre') > -1) {
    return props.selectedPartner.partnerSideBar
  }
  return props.partnerSideBarInfo
}

const iff = (condition, then, otherwise) => (condition ? then : otherwise)

const trimString = (value, maxLenght) => {
  if (value && value.length > maxLenght) {
    const fileExtension = value.replace(/^.*\./, '')
    const trimmedString = `${value.substring(0, maxLenght)}..1${value.replace(fileExtension, '').substring(value.length - 3, value.length)}.${fileExtension}`
    return trimmedString
  }
  return value
}

const isAdminPortal = () => {
  return (window.location.href.indexOf('admin/admincentre') > 0)
}

export const commonFunctions = {
  checkPartnerSideBar,
  iff,
  trimString,
  isAdminPortal,
}




// WEBPACK FOOTER //
// ./src/utils/CommonFunctions.js